import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { ISucceededSlipResult } from '../../../betplacement/models';
import { TokenPayoutSummary } from '../../models/betslip-result-summary.model';

@Component({
    selector: 'bs-digital-result-slips',
    templateUrl: './result-slips.component.html',
    styleUrls: ['./result-slips.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultSlipsComponent {
    @Input() succeededSlips: ISucceededSlipResult[];
    @Input() tokenPayoutSummaries?: TokenPayoutSummary[];
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() possibleWinningTitle: string;
    @Input() teasedPoints?: number;

    @HostBinding('class') className = 'betslip-result-slips';

    get isTeaserBet(): boolean {
        return this.succeededSlips[0]?.picks[0]?.isTeaserBet ?? false;
    }

    getSlipTokenPayoutSummary(slip: ISucceededSlipResult): TokenPayoutSummary | undefined {
        return this.tokenPayoutSummaries?.find((summary) => summary.betNumber === slip.betNumber);
    }
}
